import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { PostHogProvider } from './providers/PostHogProvider'
import './styles/globals.css'

// Initialize theme from localStorage before render to prevent flash
const initializeTheme = () => {
  const stored = localStorage.getItem('theme-storage')
  let theme = 'system'

  if (stored) {
    try {
      const parsed = JSON.parse(stored)
      theme = parsed.state?.theme || 'system'
    } catch {
      // Ignore parse errors
    }
  }

  const resolvedTheme =
    theme === 'system'
      ? window.matchMedia('(prefers-color-scheme: dark)').matches
        ? 'dark'
        : 'light'
      : theme

  document.documentElement.classList.add(resolvedTheme)
}

initializeTheme()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PostHogProvider>
      <App />
    </PostHogProvider>
  </React.StrictMode>
)
